import React, { FC } from "react";
import { Typography, Grid, Box } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { useDPTheme } from "Styles/useDPTheme";

export interface HelpTextProps {
  disableTypography?: boolean;
}

export const HelpText: FC<HelpTextProps> = ({
  disableTypography,
  children,
}) => {
  const { themeSpecificColors } = useDPTheme();

  return (
    <Grid container item xs={12} spacing={0} direction="row">
      <HelpOutlineIcon
        style={{ color: themeSpecificColors.helpIconColor, marginRight: 16 }}
      />
      <Box maxWidth="90%">
        {disableTypography ? (
          children
        ) : (
          <Typography component="p">{children}</Typography>
        )}
      </Box>
    </Grid>
  );
};
